import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function Forbidden() {
    return (
        <div
            className="min-h-screen flex items-center justify-center px-4 asl-login-bg"
            data-testid="forbidden-page"
        >
            <div className="asl-card p-10 max-w-md text-center">
                <div className="text-7xl font-extrabold asl-crimson-text mono">
                    403
                </div>
                <h1 className="text-2xl font-bold asl-navy-text mt-2">
                    You can't view this page
                </h1>
                <p className="text-sm text-[color:var(--asl-muted)] mt-2">
                    Your role doesn't include access to this section. If you think this is a mistake, ask an admin to review your permissions.
                </p>
                <Link to="/">
                    <Button
                        className="mt-6 asl-navy-bg text-white"
                        data-testid="forbidden-back-button"
                    >
                        Back to Home
                    </Button>
                </Link>
            </div>
        </div>
    );
}
